var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1648_1960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5H24.5V15H21.7578L15.6992 4.5L14.4922 6.57422C14.0625 5.91016 13.5508 5.31641 12.957 4.79297C12.3633 4.26953 11.7109 3.83203 11 3.48047V1.5ZM13.4023 8.47266L7.91797 17.9648C7.69141 17.9883 7.46875 18 7.25 18C6.32031 18 5.44531 17.8242 4.625 17.4727C3.80469 17.1211 3.08984 16.6367 2.48047 16.0195C1.87109 15.4023 1.39062 14.6875 1.03906 13.875C0.6875 13.0625 0.507812 12.1875 0.5 11.25C0.5 10.3203 0.675781 9.44531 1.02734 8.625C1.37891 7.80469 1.86328 7.08984 2.48047 6.48047C3.09766 5.87109 3.8125 5.39062 4.625 5.03906C5.4375 4.6875 6.3125 4.50781 7.25 4.5C7.91406 4.5 8.55469 4.59375 9.17188 4.78125C9.78906 4.96875 10.3672 5.23438 10.9062 5.57812C11.4453 5.92188 11.9258 6.33594 12.3477 6.82031C12.7695 7.30469 13.1211 7.85547 13.4023 8.47266ZM7.47266 22.5L15.6992 8.25L23.9258 22.5H7.47266Z",
    fill: "#181038"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1648_1960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes);
export default __webpack_public_path__ + "static/media/shapes.79c47c35ac27f8da13e3b57aedd5b8bf.svg";
export { ForwardRef as ReactComponent };